module.exports = __webpack_public_path__ + "static/img/wnr@3x.1bce19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wnr@3x.png
// module id = GcId
// module chunks = 1